import Exception from '../lang/Exception'

export default class NoSuchElementException extends Exception { }